<template>
    <div class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm">
      <div class="bg-white rounded-2xl shadow-2xl w-full max-w-md max-h-[95vh] flex flex-col">
        <div class="p-4 sm:p-6">
          <div class="mb-4">
            <ul class="flex border-b justify-center">
              <li class="mr-1">
                <a :class="{'border-blue-500 text-blue-600 bg-blue-50': tab === 'expense', 'text-gray-500 hover:text-gray-700': tab !== 'expense'}"
                   @click="tab = 'expense'"
                   class="inline-block py-2 px-4 text-center text-sm font-semibold cursor-pointer border-b-2 transition-all duration-300 rounded-t-lg">
                  支出
                </a>
              </li>
              <li class="ml-1">
                <a :class="{'border-blue-500 text-blue-600 bg-blue-50': tab === 'income', 'text-gray-500 hover:text-gray-700': tab !== 'income'}"
                   @click="tab = 'income'"
                   class="inline-block py-2 px-4 text-center text-sm font-semibold cursor-pointer border-b-2 transition-all duration-300 rounded-t-lg">
                  收入
                </a>
              </li>
            </ul>
          </div>
          <form @submit.prevent="handleAddEntry" class="space-y-4 overflow-y-auto max-h-[calc(90vh-150px)]">
            <div>
              <label class="block text-gray-700 text-xs font-medium mb-1" for="date">日期</label>
              <input type="date" v-model="date" class="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all duration-300"/>
            </div>
            <div>
              <label class="block text-gray-700 text-xs font-medium mb-1" for="amount">金额</label>
              <div class="relative">
                <input type="number" v-model="amount" step="0.01" class="w-full pl-3 pr-12 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all duration-300" placeholder="请输入金额"/>
                <span class="absolute right-3 top-2.5 text-gray-400 text-sm">元</span>
              </div>
              <p v-if="errors.amount" class="text-red-500 text-xs mt-1">{{ errors.amount }}</p>
            </div>
            <div>
              <label class="block text-gray-700 text-xs font-medium mb-1">分类</label>
              <div class="grid grid-cols-4 gap-2">
                <div v-for="category in filteredCategories" :key="category"
                     @click="selectCategory(category)"
                     :class="{'ring-2 ring-blue-500 bg-blue-50': selectedCategory === category, 'hover:bg-gray-50': selectedCategory !== category}"
                     class="border p-2 rounded-lg cursor-pointer transition-all duration-100 flex flex-col items-center justify-center">
                  <span class="text-xl mb-0.5">{{ getEmoji(category) }}</span>
                  <span class="text-xs">{{ category }}</span>
                </div>
              </div>
              <p v-if="errors.category" class="text-red-500 text-xs mt-1">{{ errors.category }}</p>
            </div>
            <div>
              <label class="block text-gray-700 text-xs font-medium mb-1" for="note">备注</label>
              <input v-model="note" class="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all duration-300" placeholder="添加备注（选填）"/>
            </div>
          </form>
        </div>
        <div class="p-4 bg-gray-50 rounded-b-2xl">
          <div class="flex items-center justify-end space-x-4">
            <button @click="$emit('close')" type="button" class="px-4 py-2 border border-gray-300 rounded-md text-sm text-gray-700 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-500 transition-all duration-300">
              取消
            </button>
            <button @click="handleAddEntry" type="button" class="px-4 py-2 bg-blue-500 text-sm text-white rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all duration-300">
              保存
            </button>
          </div>
        </div>
      </div>
    </div>
  </template>


  <script>
import { mapActions } from 'vuex'
import { getEmoji } from '@/utils/util.js' // Adjust the path as necessary

export default {
  data() {
    return {
      tab: 'expense',
      date: new Date().toISOString().substr(0, 10),
      amount: '',
      selectedCategory: '',
      categories: {
        income: ['工资', '奖金', '退款', '红包', '兼职', '退税', '理财', '报销'],
        expense: ['购物', '餐饮', '交通', '娱乐', '学习', '旅游', '家庭', '订阅']
      },
      note: '',
      errors: {
        amount: '',
        category: ''
      }
    }
  },
  computed: {
    filteredCategories() {
      return this.categories[this.tab];
    }
  },
  methods: {
    ...mapActions(['addEntry']),
    selectCategory(category) {
      this.selectedCategory = category;
    },
    validateEntry() {
      let isValid = true;
      this.errors.amount = '';
      this.errors.category = '';

      if (!this.amount || isNaN(this.amount) || parseFloat(this.amount) <= 0) {
        this.errors.amount = '请输入有效的金额';
        isValid = false;
      }

      if (!this.selectedCategory) {
        this.errors.category = '请选择一个分类';
        isValid = false;
      }

      return isValid;
    },
    handleAddEntry() {
      if (this.validateEntry()) {
        const entry = {
          id: new Date().getTime(),
          date: this.date,
          amount: this.amount,
          category: this.selectedCategory,
          note: this.note,
          type: this.tab
        };
        this.addEntry(entry);
        this.$emit('close');
      }
    },
    getEmoji
  }
}
</script>

  
  <style scoped>
  /* 自定义样式 */
  label {
    text-align: left;
  }
  </style>
  